import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteIVR } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useDeleteIVR({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: deleteIVR,
    mutationKey: ['deleteIVR'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getIVRList']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
